
import moment from 'moment'
import React from 'react'
import { getValueFromResource } from '../../common/timeLiveFunction'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { useNavigate } from 'react-router-dom'
import { MarkCalendarReminderAsRead } from '../calendar/CalendarSlice'
import { GetCalendarEventsForNotification } from '../../common/GlobalSlice'
import { Tooltip as ReactTooltip } from 'react-tooltip';
import bellIcon from "../../assets/image/bell-icon.png";

const NotificationWidget = (prop: any) => {
    const { t } = prop
    const dispatch = useAppDispatch();
    const { notificationEvents, accountFeatureList } = useAppSelector((state) => state.globalState);
    const showCalendar = accountFeatureList?.some((item: any) => item?.Id === '9289f75c-48be-4002-bef6-df8be6e014cb') ?? false;
    const navigate = useNavigate();
    const currentDate = moment().format('YYYY-MM-DD');
    const savedNotifications = localStorage.getItem("Notification");
    const notifications = savedNotifications ? JSON.parse(savedNotifications) : [];

    const handleMarksAsRead = async () => {
        const parload = notifications?.map((item: any) => ({
            AccountEmployeeReminderId: item?.AccountEmployeeReminderId
        }))
        await dispatch(MarkCalendarReminderAsRead(parload))
        await dispatch(GetCalendarEventsForNotification(currentDate));
    }

    const handleSingleReadNotification = async (id: any) => {
        const obj = [{
            AccountEmployeeReminderId: id
        }]
        await dispatch(MarkCalendarReminderAsRead(obj))
        await dispatch(GetCalendarEventsForNotification(currentDate));
    }

    return (
        <div
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 mt-2 fs-6 w-300px h-300px"
            data-kt-menu="true"
        >
            <div className="d-flex justify-content-between align-items-center px-3">
                <h4 className="headerTitle">{getValueFromResource('Notifications', dispatch, t)}</h4>
                {(showCalendar && notificationEvents?.length > 0) && (
                <div className="d-flex cursor-pointer mt-1" onClick={handleMarksAsRead}>
                    <i className="bi bi-check2 text-primary fs-5 me-1" style={{marginTop: '1px'}}></i>
                    <span className="fw-bold text-primary" style={{fontSize: '11px'}}>{getValueFromResource('Mark all as read', dispatch, t)}</span>
                </div>
                )}
            </div>
            <div className="separator mt-2"></div>
            {(showCalendar && notificationEvents?.length > 0) ? (
                <>

                    <div className="list-group" style={{ overflowY: "auto" }}>
                        {notificationEvents?.map((item: any, index: any) => {

                            return (
                                <>
                                    <div
                                        key={index}
                                        className="notification-item list-group-item d-flex justify-content-between align-items-center py-2 px-3 border-0"
                                    >
                                        <div className="d-flex align-items-start gap-1 flex-column">
                                            <div className="d-flex align-items-center gap-2 cursor-pointer" onClick={() => navigate('/calendar')}>
                                                <i className="bi bi-bell fs-7 notification-icon"></i>
                                                <div className="d-flex flex-column">
                                                    <h4 className=" text-truncate" style={{ maxWidth: "150px", lineHeight: 1.2, fontSize: '12px' }}>{getValueFromResource(`${item.EventName}`, dispatch, t)}</h4>
                                                    <small className='tsNavBarInfoLabel'>
                                                        {moment(item.StartTime).format('hh:mm A')} -{' '}
                                                        {moment(item.EndTime).format('hh:mm A')}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <span className="hover-check-icon" onClick={() => handleSingleReadNotification(item?.AccountEmployeeReminderId)}>
                                                {/* {totalTime} */}
                                                <i className="bi bi-check-circle fs-5 cursor-pointer" data-tooltip-id="tooltip-notification" data-tooltip-content={getValueFromResource('Mark as read', dispatch, t)}></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="separator"></div>
                                </>
                            )
                        })}
                    </div>
                </>
            ) : (
                <>
                    <div
                        className="d-flex flex-column justify-content-center align-items-center text-center h-100 px-4"
                        style={{ height: '240px', paddingLeft: '24px', paddingRight: '24px' }}
                    >
                        <img src={bellIcon} alt="Bell Icon" height={60} width={60} />
                        <h6 className="mt-3 mb-1 fw-semibold" style={{ color: '#1e1e1e' }}>
                            No notification yet
                        </h6>
                        <p
                            className="fs-7 mt-1"
                            style={{
                                color: '#7a7a7a',
                                lineHeight: '1.4',
                                wordWrap: 'break-word',
                                textAlign: 'center',
                                maxWidth: '220px',
                            }}
                        >
                            You’ll see notifications here when they are available
                        </p>
                    </div>
                </>
            )}
            <ReactTooltip
                id="tooltip-notification"
                style={{
                    fontSize: 12,
                    fontWeight: 'normal',
                    padding: 8,
                    borderRadius: 6,
                    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                    backgroundColor: 'black',
                    color: 'white',
                    zIndex: 10000
                }}
                place="top"
            />
        </div>
    )
}

export default NotificationWidget
